module.exports = __webpack_public_path__ + "static/media/maestrokwonymaestrotak.770ebb88.jpg";